import moment from "moment"

export const formatDate = (date: Date | string) => moment.parseZone(date).format('DD MMM YYYY')
export const formatDayTime = (date: Date | string) => moment.parseZone(date).format('DD-MM-yyyy hh:mm a')
export const formatForDatestamp = (date: Date | string) => moment.parseZone(date).format('yyyy-MM-dd')
export const formatDay = (date: Date | string) => moment.parseZone(date).format('DD-MM-yyyy')
export const formatDayInYearMonthFormat = (date: Date | string) => moment.parseZone(date).format('yyyy-MM')
export const formatDayInYearMonthDayFormat = (date: Date | string) => moment.parseZone(date).format('yyyy-MM-DD')
export const formatInYearMonthDayFormat = (date: Date | string) => moment.parseZone(date).format('yyyy-MM-DD')
